module.exports = __webpack_public_path__ + "static/media/share_icon.c88acc97.svg";